// src/lib/config/search-menu.js

import Faces from '@faces/Faces.svelte';
import CamView from '@components/cameras/CamView.svelte';
import Lists from '@components/Lists.svelte';
import AgGrid from '@components/AgGrid.svelte';
import ToTalk from '@components/messenger/ToTalk.svelte';

export const COMPONENTS = {
    Faces,
    CamView,
    Lists,
    AgGrid,
    ToTalk
};
